import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {  MatAutocompleteModule } from '@angular/material/autocomplete';
import {  MatInputModule } from '@angular/material/input';
import {  MatOptionModule } from '@angular/material/core';
import { TypeaheadDropdownComponent } from './typeahead-dropdown.component';
import { FilterByPipeModule } from '../../../pipes';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@NgModule({
  declarations: [TypeaheadDropdownComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FilterByPipeModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatOptionModule,
    FontAwesomeModule,
  ],
  exports: [
    TypeaheadDropdownComponent,
  ],
})
export class TypeaheadDropdownModule {}
